import styles from './Heart.module.css'

const Heart = ({active=false, onClick}) => {
  return (
      <svg className={styles[active ? 'active' : 'inactive']} viewBox="0 0 1000 1000" onClick={onClick}><path
        d="M 499 897 C 491 897 483 894 476 888 C 476 888 123 544 110 527 C 97 511 85 494 75 477 C 64 461 55 440 47 415 C 39 390 35 366 35 343 C 35 267 57 208 101 165 C 145 122 206 100 283 100 C 304 100 326 104 348 111 C 370 118 391 129 410 142 C 430 155 446 166 461 177 C 475 188 488 199 499 212 C 512 200 524 188 538 177 C 552 166 568 154 588 142 C 608 129 629 119 650 111 C 672 103 694 99 716 100 C 793 100 854 122 898 165 C 942 208 964 268 964 343 C 964 420 924 497 845 577 L 523 888 C 517 894 509 897 499 897 Z"></path></svg>
  )
}
export default Heart